import { render } from "./CallBackView.vue?vue&type=template&id=39f46b62&ts=true"
import script from "./CallBackView.vue?vue&type=script&lang=ts"
export * from "./CallBackView.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\y-sakakibara\\Documents\\Git\\workflow-system\\workflow\\frontend\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__